export enum LogType {
  Information,
  Warning,
  Error
}
